"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "execCommand", {
    enumerable: true,
    get: function() {
        return command;
    }
});
const _commander = require("commander");
const _action = require("./action.js");
const _addOptions = require("../addOptions.js");
const command = new _commander.Command("exec");
(0, _addOptions.addOptions)("pool", command);
(0, _addOptions.addOptions)("runner", command);
(0, _addOptions.addOptions)("server", command);
(0, _addOptions.addOptions)("logger", command);
command.action(_action.execAction);
